import { BusStop } from '@/types/logs'

type StopValue = { direction: string; stopNumber: string }

export const generateLocationStopValue = (stop: BusStop): string => `${stop.direction}/${stop.stopNumber}`
export const parseLocationStopValue = (id: string): StopValue => {
    const [direction, stopNumber] = id.split('/')

    return {
        direction,
        stopNumber,
    }
}
